import { get } from "@insite/client-framework/Services/ApiService";

export interface AccountDetails {
    customerName: string
    properties: Properties
  }
    
  export interface Properties {}
  const accountInformationUrl = "api/v1/accountDetails";

  export function getAccountDetails(){
    return get<AccountDetails>(`${accountInformationUrl}`);
}